<!--
    理论试卷预览页
    无需等待异步数据加载完毕，可以直接展示该组件
    用于：组卷中预览、组卷完成后的预览、理论练习详情、
         理论考试详情（包括考试记录、学员和老师在培训任务中查看已完成的考卷、考试统计中的查看）
-->

<template>
    <div class="m-paper m-paperView" :class="{'m-paperGraphic': isGraphic}">
        <header class="paper-header">
            <div class="paper-title">
                <img src="../../assets/images/common/nav_logo.png" alt="">
                <h1>{{paperInfo.title}}</h1>
                <el-button @click="closeFn" type="danger" size="small" round><i class="nucfont inuc-close"></i>
                </el-button>
            </div>
            <div class="paper-info">
                <ul>
                    <li>
                        <h5>{{$t('exam.totalCount')}}</h5>
                        <p><b>{{topics.length}}</b> {{$t('exam.question')}}</p>
                    </li>
                    <li v-if="paperInfo.totalScore">
                        <h5>{{$t('paper.totalScore')}}</h5>
                        <p><b>{{paperInfo.totalScore}}</b> {{$t('paper.points')}}</p>
                    </li>
                    <li v-if="paperInfo.totalSeconds">
                        <h5>{{$t('exam.period')}}</h5>
                        <p><b>{{Math.floor(paperInfo.totalSeconds / 60)}}</b> {{$t('exam.min')}}</p>
                    </li>
                    <li v-if="paperInfo.score">
                        <h5>{{$t('exam.score')}}</h5>
                        <p><b>{{paperInfo.score}}</b> {{$t('paper.points')}}</p>
                    </li>
                    <li v-if="paperInfo.passScore">
                        <h5>{{$t('count.passScore')}}</h5>
                        <p><b>{{paperInfo.passScore}}</b> {{$t('paper.points')}}</p>
                    </li>
                    <li class="switch-mode" v-if="!isGraphic">
                        <el-radio-group v-model="multiMode" size="medium">
                            <el-radio-button :label="true">{{$t('exam.multiMode')}}</el-radio-button>
                            <el-radio-button :label="false">{{$t('exam.singleMode')}}</el-radio-button>
                        </el-radio-group>
                    </li>
                </ul>
            </div>
        </header>

        <div class="paper-container" >
            <div class="paper-main" v-if="topics.length">

                <aside class="paper-aside">
                    <div class="paper-aside-inner">
                        <div class="aside-box">
                            <h2 class="box-header">{{$t('exam.answerSheet')}}</h2>
                            <div class="status-desc">
                                <p><span class="undone"></span>{{$t('exam.blank')}}</p>
                                <p><span class="correct"></span>{{$t('exam.correct')}}</p>
                                <p><span class="wrong"></span>{{$t('exam.incorrect')}}</p>
                            </div>
                            <div class="box-sheet">
                                <div class="sheet-list-wrap" v-for="(obj, key) in multiTopic" v-if="obj.length">
                                    <h3> {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'),$t('paper.matching'), '快速判断', '位置标记', '位置标记及类型选择'][key - 1]}}</h3>
                                    <ul class="sheet-list">
                                        <li v-for="item in obj"
                                            :class="[{'active' : item.index+1 === number}, sheetStatus(item.topicID)]"
                                            @click="toNumber(item.index+1)">{{item.index+1}}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>

                <div v-if="multiMode" class="paper-left mode-multi">
                    <section class="paper-list" v-for="(obj, key) in multiTopic" v-if="obj.length">
                        <h2 class="box-header">
                            {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching')][key - 1]}}

                            <template v-if="paperInfo.totalScore">
                                （{{[paperInfo.singleScore, paperInfo.multipleScore, paperInfo.tfScore, paperInfo.pairScore][key - 1]}}{{$t('paper.points')}}）

                            </template>
                        </h2>
                        <!-- 题目开始 -->
                        <div class="paper-item" v-for="(item, index) in obj" :key="index" :id="item.topicID"
                             :index="item.index">
                            <div class="detail">
                                <!-- 题干 -->
                                <div class="topic-title">
                                    <i v-if="item.key" class="key-topic nucfont inuc-favor-fill"></i>
                                    <p class="no">{{item.index + 1}}.</p>
                                    <!--<span class="type">【{{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse')][item.topic.type - 1]}}】</span>-->
                                    <p class="titleRT" v-html="item.topic.titleRT"></p>
                                </div>

                                <!-- 选项 -->
                                <ul v-if="item.topic.type < 4">
                                    <li v-for="v in item.topic.options" class="topic-choice"
                                        :class="{'rightAnswer': v.isRight}">
                                        <el-radio v-if="item.topic.type === 1" :value="true"
                                                  :label="isOptionSelected(item, v)">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-radio>
                                        <el-checkbox v-if="item.topic.type === 2" :value="isOptionSelected(item, v)">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-checkbox>
                                        <el-radio v-if="item.topic.type === 3" :value="true"
                                                  :label="isOptionSelected(item, v)">
                                            <em>{{v.tagName}}</em>
                                        </el-radio>
                                    </li>
                                </ul>
                            </div>
                            <div class="match-topic" v-if="item.topic.type == 4"  v-viewer="{movable: false}">
                                <div class="match-wrap">
                                    <div class="image">
                                        <img :src="item.topic.picViewUrl ? item.topic.picViewUrl : ''" alt="">
                                    </div>
                                    <!-- <ul class="option-wrap">
                                        <li v-for="item in item.topic.rectangleOptions" :key="'m'+item.id" class="option-item"> {{item.tagName + '. '+item.answerName}}</li>
                                    </ul> -->
                                </div>
                                <div class="drop-area" v-if="item.topic.dropList.length>0">
                                    <div class="drop-item" v-for="(ele,index) in item.topic.dropList" :key="ele.id">
                                        <label class="item-tag">{{String.fromCharCode(index+65)}}.</label>
                                        <div class="drop-group selected">
                                            <div>
                                                <span class="item-name" :title="ele.answerName" :class="{'wrong':ele.wrong}">{{ele.answerName}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="no-answer" v-if="response && item.topic.dropList.length==0">此题未作答</p>
                            </div>

                            <div class="others">
                                <a class="btn-answer"
                                   :class="{'active': !hideAnswer[item.topicID]}"
                                   @click="toggleAnswer(item.topicID)"
                                >{{$t('topic.answerAnalysis')}}</a>
                                <div class="answer-area" v-show="!hideAnswer[item.topicID]">
                                    <p class="answer">
                                        <span
                                            class="tag">{{$t('paper.answer')}}：</span>{{/import/.test(item.topicID) ? getAnswer(item.topic) : item.topic.keyName}}
                                    </p>
                                    <p class="analysis" v-html="
                                       '<span class=tag>' + $t('paper.analysis') + '：</span>' + (item.topic.analysisRT||$t('c.none')) "
                                    ></p>
                                </div>
                            </div>
                        </div>
                        <!-- 题目结束 -->
                    </section>
                </div>

                <section v-else class="paper-left mode-single">
                    <section class="paper-list">
                        <h2 class="box-header">
                            {{[$t('paper.single'), $t('paper.multiple'), $t('paper.trueOrFalse'), $t('paper.matching'), '快速判断', '位置标记', '位置标记及类型选择'][singleTopic.topic.type - 1]}}
                            <template v-if="paperInfo.totalScore">
                                （{{[paperInfo.singleScore, paperInfo.multipleScore, paperInfo.tfScore, paperInfo.pairScore, paperInfo.graphicScore, paperInfo.graphicScore, paperInfo.graphicScore][singleTopic.topic.type - 1]}}{{$t('paper.points')}}）
                            </template>
                        </h2>

                        <!-- 题目开始 -->

                        <!-- 图片题 -->
                        <paper-graphic
                            v-if="isGraphic"
                            :isExam="false"
                            :response="response"
                        ></paper-graphic>

                        <!-- 普通理论题 -->
                        <div class="paper-item" v-else>
                            <div class="detail">
                                <!-- 题干 -->
                                <div class="topic-title">
                                    <i v-if="singleTopic.key" class="key-topic nucfont inuc-favor-fill"></i>
                                    <p class="no">{{number}}.</p>
                                    <p class="titleRT" v-html="singleTopic.topic.titleRT"></p>
                                </div>

                                <!-- 选项 -->
                                <ul v-if="singleTopic.topic.type < 4">
                                    <li v-for="v in singleTopic.topic.options" class="topic-choice"
                                        :class="{'rightAnswer': v.isRight}">
                                        <el-radio v-if="singleTopic.topic.type === 1" :value="true"
                                                  :label="isOptionSelected(singleTopic, v)">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-radio>
                                        <el-checkbox v-if="singleTopic.topic.type === 2"
                                                     :value="isOptionSelected(singleTopic, v)">
                                            <em>{{v.tagName}}.</em>
                                            <div class="options" v-html="v.titleRT"></div>
                                        </el-checkbox>
                                        <el-radio v-if="singleTopic.topic.type === 3" :value="true"
                                                  :label="isOptionSelected(singleTopic, v)">
                                            <em>{{v.tagName}}</em>
                                        </el-radio>
                                    </li>
                                </ul>

                                <!-- 配对题 -->
                                <div class="match-topic" v-if="singleTopic.topic.type == 4"  v-viewer="{movable: false}">
                                    <div class="match-wrap">
                                        <div class="image">
                                            <img :src="singleTopic.topic.picViewUrl ? singleTopic.topic.picViewUrl : ''" alt="">
                                        </div>
                                    </div>
                                    <div class="drop-area">
                                        <div class="drop-item" v-for="(ele, index) in singleTopic.topic.dropList" :key="ele.id">
                                            <label class="item-tag">{{String.fromCharCode(index+65)}}.</label>
                                            <div class="drop-group selected">
                                                <div>
                                                    <span class="item-name" :title="ele.answerName" :class="{'wrong':ele.wrong}">{{ele.answerName}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="no-answer" v-if="response && singleTopic.topic.dropList.length==0">此题未作答</p>
                                </div>
                            </div>

                            <div class="others">
                                <a class="btn-answer"
                                   :class="{'active': !hideAnswer[singleTopic.topicID]}"
                                   @click="toggleAnswer(singleTopic.topicID)"
                                >{{$t('topic.answerAnalysis')}}</a>
                                <div class="answer-area" v-show="!hideAnswer[singleTopic.topicID]">
                                    <p class="answer"><span
                                        class="tag">{{$t('paper.answer')}}：</span>{{/import/.test(singleTopic.topicID) ? getAnswer(singleTopic.topic) : singleTopic.topic.keyName}}
                                    </p>
                                    <p class="analysis" v-html="
                                    '<span class=tag>' + $t('paper.analysis') + '：</span>' + (singleTopic.topic.analysisRT||$t('c.none')) "
                                    ></p>
                                </div>
                            </div>
                        </div>

                    </section>
                    <!-- 题目结束 -->

                    <div class="button-group">
                        <el-button type="primary" @click="lastOne" size="medium" :disabled="number === 1">
                            {{$t('exam.prev')}}
                        </el-button>
                        <el-button type="primary" @click="nextOne" size="medium" :disabled="number === topics.length">
                            {{$t('exam.next')}}
                        </el-button>
                    </div>
                </section>
            </div>
        </div>

        <div class="fullscreen-wrapper" v-if="loading" v-loading="true">
            <p>{{$t('stu.loadingExamTip')}}</p>
        </div>

    </div>
</template>

<script>
    /**
     * paperInfo: {
     *      试卷基本信息(title、totalScore等),
     *      response,
     *      考试基本信息(isSubmit、score、totalSeconds)
     * }
     */
    import {screenfull} from '@/utils';
    import PaperGraphic from "./PaperGraphic";

    export default {
        components: {
            PaperGraphic
        },
        props: {
            // 基本数据
            paperInfo: {
                required: true,
            },
            // 试题数据
            topicData: {
                required: true,
            },
        },
        data() {
            return {
                number: 1,             //当前的题号
                multiMode: true,
                hideAnswer: {},
                singleTopic: null,
                multiTopic: null,
                response: null,          // 作答数据
                loading: true,
                isGraphic: false,        // 是否为图片题（快速判断、位置标记）
            }
        },

        mounted() {
            this.$scrollElement = $('.paper-container');

            this.initKeyboard()
        },
        computed: {
            /**
             *  对传过来的topicData二次处理：排序、添加序号
             *  为单题模式和多题模式的数据赋值
             *  topics: 处理好的题目数据
             */
            topics() {
                let topic;

                if (this.paperInfo.response) {
                    this.response = this.paperInfo.response;
                    //console.log('this.response: ', this.response);
                }

                // 是否为图片题
                this.isGraphic = this.paperInfo.method === 5
                if (this.isGraphic) this.multiMode = false
                this.topicData.forEach(item => {
                    if (item.topic.type === 7) {
                        if (item.topic.pattern===1) {
                            item.topic.type = 5
                        } else if (item.topic.pattern===2) {
                            item.topic.type = 6
                        } else if (item.topic.pattern===3) {
                            item.topic.type = 7
                        }
                    }
                })

                this.single = this.topicData.filter(item => item.topic.type === 1);
                this.multi = this.topicData.filter(item => item.topic.type === 2);
                this.choice = this.topicData.filter(item => item.topic.type === 3);
                this.match = this.topicData.filter(item => item.topic.type === 4);
                this.graphicQuick = this.topicData.filter(item => item.topic.type === 5);
                this.graphicMark = this.topicData.filter(item => item.topic.type === 6);
                this.graphicMarkAndSelect = this.topicData.filter(item => item.topic.type === 7);

                // 排序
                topic = [...this.single, ...this.multi, ...this.choice, ...this.match, ...this.graphicQuick, ...this.graphicMark, ...this.graphicMarkAndSelect];

                /**
                 * 为每一个topic绑定序号index
                 * 如果是导入的情况，没有topicID，则手动生成一个id: import_{index}
                 */
                topic.forEach((item, index) => {
                    item.index = index;
                    if (!this.response && !item.topicID) {
                        item.topicID = 'import_' + index;
                    }
                    if(item.topic.type==4){
                        item.topic.dropList = []
                    }
                });
                if(this.response){
                    topic.forEach(itm => {
                        this.response.forEach(res =>{
                            if(res.topicID == itm.topicID && itm.topic.type==4){
                                if(res.answer.length>0){
                                    // 如果有未作答的选项，这道题就算未作答
                                    if (res.answer.includes(0)) {
                                        return itm.topic.dropList = []
                                    }

                                    let answers = []
                                    res.answer.forEach((ele,index) => {
                                        let idx = itm.topic.rectangleOptions.findIndex(v=>v.answerId == ele)
                                        let option = itm.topic.rectangleOptions[idx]
                                        if (!option) return
                                        option.wrong = true
                                        if(ele == itm.topic.key[index]){
                                            option.wrong = false
                                        }
                                        answers.push(option)
                                    })
                                    itm.topic.dropList = answers
                                }
                            }
                        })
                    });
                }
                this.singleTopic = topic[this.number - 1];
                this.multiTopic = {
                    1: this.single,
                    2: this.multi,
                    3: this.choice,
                    4: this.match,
                    5: this.graphicQuick,  // 快速判断
                    6: this.graphicMark,  // 位置标记
                    7: this.graphicMarkAndSelect // 位置标记及类型选择
                };

                return topic;
            },
        },
        methods: {
            lastOne(){
                this.number > 1 && this.number--;
            },
            nextOne(){
                this.number < this.topicData.length && this.number++;
            },
            sheetStatus(topicID) {
                let status = '';

                if (!this.response) return status;

                let response = this.response.find(v => v.topicID === topicID);
                let answer = response.answer

                let singleHasContent = typeof answer === 'number'
                let multiHasContent = Array.isArray(answer) && answer.length
                let graphicHasContent = Object.prototype.toString.call(answer) === '[object Object]' && answer.isPass!==null

                if (singleHasContent || multiHasContent || graphicHasContent) {
                    status = response.result ? 'correct' : 'wrong';
                } else {
                    status = '';
                }

                return status;
            },
            toNumber(n) {
                this.number = n;

                if (this.multiMode) {
                    this.$scrollElement.scrollTop($("[index=" + (n-1) + "]").position().top - 15);
                }
            },
            isOptionSelected(topicData, option) {
                if (!this.response) return option.isRight;

                let answer = this.response.find(v => v.topicID === topicData.topicID).answer;

                if (topicData.topic.type !== 2) {
                    return answer === option.id;
                } else {
                    return answer.indexOf(option.id) > -1;
                }
            },
            toggleAnswer(id) {
                this.$set(this.hideAnswer, id, !this.hideAnswer[id])
            },

            getAnswer(item) {
                let rst = '';

                if (item.type === 3) {
                    rst = item.options.find(ele => ele.tag === 1).isRight ? this.$t('c.right') : this.$t('c.wrong');
                } else {
                    item.options.forEach(val => {
                        if (val.isRight) rst += `,${val.tagName}`;
                    });
                    rst = rst.substring(1);
                }

                return rst;
            },

            initKeyboard() {
                $(document).on('keydown.paper', e => {
                    let key = e.keyCode
                    if (this.multiMode) return
                    // 左
                    if (key === 37) {
                        this.lastOne()
                    }
                    // 右
                    if (key === 39) {
                        this.nextOne()
                    }
                })
            },

            closeFn(){
                this.$emit('close');
            },
        },
        watch: {
            paperInfo(val) {
                console.log('试卷总数据', val);
            },
            topicData: {
                handler: function (val) {
                    if (val.length) {
                        //console.log('试题数据', val);
                        setTimeout(() => {
                            this.loading = false;
                        }, 500);
                    }
                },
                immediate: true
            }
        },
        beforeDestroy() {
            $(document).off('keydown.paper')
            screenfull.exit();
        },
    }
</script>

<style lang="scss">
    @import './Paper';

    .fullscreen-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #fff;
        z-index: 3000;

        > p {
            position: absolute;
            top: 53%;
            left: 50%;
            transform: translateX(-50%);
            font-size: 16px;
            color: #000;
            z-index: 9000;
        }
    }

    .m-paperView {
        .no-answer{
            padding: 10px 5px;
            color: #f4516c;
        }
    }

</style>
